<template>
  <div class="page-content">

    <!-- 角色搜索以及添加栏目 -->
    <div class="product-menu">
      <div class="left">
        <el-button type="primary" class="first-btn" @click="addBusiness">添加厂商</el-button>
      </div>
      <div class="right" style="width: 18%">
        <el-input v-model="businessName"  placeholder="请输入厂商名称" ></el-input>
        <el-button type="primary" icon="el-icon-search"></el-button>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
         prop="roleName"
          label="厂商名称">
        </el-table-column>
        <el-table-column
          prop="total"
          label="所属区域">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
             <div class="opreationBtn">
              <span class="check" @click="handlerClick('edit',scope.row)">编辑</span>
            </div>
             <div class="opreationBtn">
              <span class="del" @click="handlerClick('del',scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row :span="24" class="dataListOperation">
        <el-row :span="24" type="flex" justify="end">
            <div class="showAll"> 共<span>{{pageParams.total}}</span>个模板信息</div>
            <el-pagination
             layout="prev, pager, next"
             @current-change="currentPageChange"
              :page-size="pageParams.pageSize"
              :pager-count="11"
              :total="pageParams.total">
            </el-pagination>
          </el-row>
      </el-row>
    </div>

    <!-- 编辑/添加厂商模板弹窗 -->
    <businessTemplateView
     v-if="addDialogVisible"
      :addDialogVisible="addDialogVisible"
      :editData="editData"
      @closeAddViewDialog="addDialogVisible = false"
    ></businessTemplateView>

  </div>
</template>
<script>
import businessTemplateView from '@/components/template/businessTemplateView'
export default {
  components: {
    businessTemplateView
  },
  data () {
    return {
      cellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      pageParams: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      businessName: '',
      addDialogVisible: false,
      editData: null
    }
  },
  methods: {
    handlerClick (type, row) {
      console.log('详情row：', row)
      if (type === 'edit') {
        this.editData = Object.assign({}, row)
        this.addDialogVisible = true
      } else {
        this.$confirm('确定删除此设备?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          console.log('确定删除')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    addBusiness () {
      this.editData = null
      this.addDialogVisible = true
    },
    currentPageChange (num) {
      // this.pageParams.pageNumber = num
    }
  }
}
</script>
<style lang="less" scoped>
.page-content{
  .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }
      .right{
        display: flex;
      }
    }
  .dataList{
    margin-top: 10px;
      background-color: white;
      .opreationBtn{
        .check{
          color: #35a6df;
          cursor: pointer;
        }
        .del{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
